// Source/Expandable/Debounce.ts
function debounce(func, wait) {
  let timeout = null;
  return (...args) => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      func(...args);
    }, wait);
  };
}

// Source/Expandable/mod.ts
var Extra_Threshold = 2;

class Expandable extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    const update = this.update.bind(this);
    const debounced = debounce(update, 100);
    window.addEventListener("resize", debounced, { signal });
    this.$input.addEventListener("change", update, { signal });
    requestAnimationFrame(update);
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  update() {
    const { $content: content } = this;
    let row = 1;
    const elements = Array.from(content.children);
    if (elements.length == 0)
      return;
    let offset = 0, space = 0;
    for (const element of elements) {
      const sibling = element.previousElementSibling;
      if (sibling && element.offsetTop > sibling.offsetTop)
        row++;
      if (row > Extra_Threshold) {
        offset = sibling.getBoundingClientRect().top - sibling.parentElement.getBoundingClientRect().top;
        space = sibling.getBoundingClientRect().height;
        break;
      }
    }
    const height = offset > 0 ? `${offset + space}px` : "auto";
    this.style.setProperty("---Height", height);
    const expand = height != "auto";
    if (!expand || this.$input.checked) {
      const element = elements.at(elements.length - 1);
      space = element.offsetHeight;
    }
    this.style.setProperty("---Space", `${space}px`);
    this.dataset.expand = String(expand);
  }
}

// Source/Collectings-Section/Component.ts
class Collectings_Section extends Expandable {
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  connectedCallback() {
    super.connectedCallback();
  }
  get $input() {
    return this.querySelector(`[ part = 'Input' ]`);
  }
  get $content() {
    return this.querySelector(`[ part = 'Content' ]`);
  }
}

// Source/Collectings-Section/mod.ts
customElements.define("collectings-section", Collectings_Section);
